import { css } from 'styled-components';
import { colorsV2 } from '../../colors-v2';

export const typeStyles = css`
  border: 1px solid;
  border-color: ${colorsV2.black20};
  background-color: ${colorsV2.white100};
  color: ${colorsV2.black80};

  &.type-answered {
    border-color: ${colorsV2.white100};
    background-color: ${colorsV2.blue10};
    color: ${colorsV2.blue100};
  }

  &.type-wrong {
    border-color: ${colorsV2.white100};
    background-color: ${colorsV2.primary20};
    color: ${colorsV2.primary100};
  }

  &.type-correct {
    border-color: ${colorsV2.white100};
    background-color: ${colorsV2.green20};
    color: ${colorsV2.green100};
  }
  &.type-missed {
    border-color: ${colorsV2.white100};
    background-color: ${colorsV2.black5};
    color: ${colorsV2.black100};
  }

  &.type-disabled {
    border-color: ${colorsV2.white100};
    background-color: ${colorsV2.gray20};
    color: ${colorsV2.black40};
    cursor: not-allowed;
  }

  &:hover {
    outline: 2.5px solid;
    outline-color: ${colorsV2.black10};

    &.type-answered {
      outline-color: ${colorsV2.blue40};
    }

    &.type-wrong {
      outline-color: ${colorsV2.primary40};
    }

    &.type-correct {
      outline-color: ${colorsV2.green40};
    }

    &.type-missed {
      outline-color: ${colorsV2.black10};
    }

    &.type-disabled {
      outline-color: ${colorsV2.gray40};
    }
  }

  &:active,
  &.selected {
    outline: 2.5px solid;
    outline-color: ${colorsV2.black80};

    &.type-correct {
      outline-color: ${colorsV2.green100};
    }

    &.type-wrong {
      outline-color: ${colorsV2.primary100};
    }

    &.type-missed {
      outline-color: ${colorsV2.black80};
    }

    &.type-answered {
      outline-color: ${colorsV2.blue100};
    }

    &.type-disabled {
      outline-color: ${colorsV2.black40};
    }
  }
`;
